<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>平台优惠券</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          class="search-form"
          size="small"
        >
          <el-form-item label="优惠券名称" prop="name">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入优惠券名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="使用平台" prop="platformId">
            <el-select
              v-model="searchForm.platformId"
              placeholder="请选择使用平台"
              filterable
              clearable
            >
              <el-option
                v-for="item in platformList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="searchForm.status"
              placeholder="请选择状态"
              filterable
              clearable
            >
              <el-option label="已启用" :value="1"></el-option>
              <el-option label="已禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="fetchData('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div style="display: flex; align-items: center">
          <h3 style="margin-bottom: 0">列表数据</h3>
        </div>
        <div>
          <el-button type="primary" @click="add('add')">新增优惠券</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table
          v-loading="loading"
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo"
          :page-size="searchForm.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable
  },
  data () {
    return {
      dataList: {
        list: [
          { title: '矩阵管理', path: '', type: '0' },
          { title: '平台优惠券管理', path: '', type: '1' }
        ]
      },
      searchForm: {
        name: '',
        platformId: '',
        status: '',
        pageNo: 1,
        pageSize: 10
      },
      openTime: [],
      statuss: [
        {
          id: '0',
          name: '未上线'
        },
        {
          id: '1',
          name: '已上线'
        }
      ],
      list: [],
      columns: [
        { label: '优惠券名称', prop: 'name', minWidth: '120' },
        { label: '使用平台', prop: 'platformInfo', minWidth: '120' },
        {
          label: '优惠内容', prop: 'couponText', minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <p style="max-height: 60px;line-height:30px; overflow: hidden;text-overflow: ellipsis;word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;">{scope.row.couponText ? scope.row.couponText : '--'}</p>
              </div>
            )
          }
        },
        { label: '优惠金额', prop: 'price', minWidth: '120' },
        { label: '已领取', prop: 'hasNum', minWidth: '120' },
        { label: '已使用', prop: 'useNum', minWidth: '120' },
        {
          label: '创建时间', prop: 'createdTime', minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.createdTime ? scope.row.createdTime : '--'}</p>
              </div>
            )
          }
        },
        {
          label: '状态',
          minWidth: '100',
          render: (h, scope) => {
            return (
              <div>
                <p class={scope.row.status == 1 ? 'success' : 'danger'}>{scope.row.status == 1 ? '已启用' : '已禁用'}</p>
              </div>
            )
          }
        },
        {
          label: '操作',
          minWidth: '180',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <el-dropdown onCommand={($event) => { this.handleCommand($event, scope.row.id) }} placement="bottom">
                  <span class="el-dropdown-link" style="color: #4168e7">
                    更多<i class="el-icon-arrow-down el-icon--right" style="color: #4168e7"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit" onClick={() => { this.add('edit', scope.row.id) }}>查看/编辑</el-dropdown-item>
                    <el-dropdown-item command="delete">删除</el-dropdown-item>
                    <el-dropdown-item command="receive">领取详情</el-dropdown-item>
                    <el-dropdown-item command="use">使用详情</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                {/* <el-link size='mini' type='primary' onClick={() => { this.add('edit', scope.row.id) }}>查看/编辑</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.add('look', scope.row.id) }}>删除</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.add('receive', scope.row.id) }}>领取详情</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.add('use', scope.row.id) }}>使用详情</el-link> */}
              </div>
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      categoryList: [],
      dictionaries: {},
      loading: false,
      platformList: []
    }
  },
  created () {
    this.goodsPlatforms()
    this.getList()
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == 'newCoupon') {
      next(vm => {
        vm.getList();
      });
    } else {
      next(vm => {
        vm.getList();
      });
    }
  },
  mounted () {

  },
  methods: {
    handleCommand (e, id) {
      console.log(e)
      if (e == 'edit') {
        this.add('edit', id)
      } else if (e == 'receive') {
        this.add('receive', id)
      } else if (e == 'use') {
        this.add('use', id)
      } else {
        const msg = `删除后不可恢复数据，是否继续？`
        this.$confirm(msg, '提示', {
          title: '提示信息',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          const params = { id: id }
          this.$api.deletePsCoupon(params).then((res) => {
            this.getList()
            this.$message({ type: 'success', message: '操作成功!' })
          }).catch((err) => {
            console.log(err)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      }
    },
    fetchData (type) {
      this.searchForm.pageNo = 1;
      if (type == 'reset') {
        this.$refs['searchForm'].resetFields()
      }
      this.getList()
    },
    goodsPlatforms () {
      const params = {
        userId: null,
        username: null,
        phone: null,
        vipLevel: null,
        categoryIds: null,
        openTimeStart: null,
        openTimeEnd: null,
        status: 1
      }
      this.$api.goodsPlatforms(params).then((res) => {
        this.platformList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    getList () {
      this.axios.post('/ps/psCoupon/getPageList', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            res.data.list.forEach(item => {
              item.price = Number(item.price).toFixed(2)
            })
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum
          }
        })
    },
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.searchForm.pageNo = currentChange
      this.getList()
    },
    handleSizeChange (sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.getList()
    },

    // 获取字典数据
    getDictionaries (type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries['platform_vip_level'] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    add (type, id) {
      if (type == 'look') {
        this.$router.push({
          name: 'lookPlatform',
          query: {
            type: type,
            id: id
          }
        })
      } else if (type == 'receive') {
        console.log(55555)
        this.$router.push({
          name: 'receiveDetail',
          query: {
            type: type,
            id: id
          }
        })
      } else if (type == 'use') {
        console.log(55555)
        this.$router.push({
          name: 'useDetail',
          query: {
            type: type,
            id: id
          }
        })
      } else if (type == 'add' || type == 'edit') {
        this.$router.push({
          name: 'newCoupon',
          query: {
            type: type,
            id: id
          }
        })
      } else {
        this.$router.push({
          name: 'platListDetail',
          query: {
            type: type,
            id: id
          }
        })
      }

    },
    setting () {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    }
  }
}
</script>
<style  lang="scss">
.el-cascader-panel {
  .el-scrollbar:first-child {
    .el-checkbox {
      display: none;
    }
  }
}
</style>
<style scoped lang="scss">
.couponText {
}
::v-deep .el-cascader-panel:first-child .el-checkbox {
  display: none !important;
}

::v-deep .el-cascader-panel li[aria-haspopup] .el-checkbox {
  display: none !important;
}

.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}

.title {
  display: flex;
  justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
  
  